import { MainHeader, SectionParagraph } from '@/components/shared/Content';
import { Flex } from '@lemonade-hq/cdk';
import { HeroCTA } from './HeroCTA';
import styled from 'styled-components';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';

const StyledHeader = styled(MainHeader)`
  ${MEDIA_QUERIES.tabletAndDesktop`
    white-space: pre-line;
  `}
`;

export interface HeroProps {
  title: string;
  subtitle: string;
  ctaLabel?: string;
  ctaUrl?: string;
}

export const Hero: React.FC<HeroProps> = ({ title, subtitle, ctaLabel, ctaUrl }) => (
  <Flex position="relative" flexDirection="column" alignItems="center" px={[20, 20, 0, 0]} mb="48px" mt="48px">
    <Flex flexDirection="column" gap="32px" alignItems="center">
      <Flex alignItems="center" flexDirection="column" gap="12px">
        <StyledHeader>{title}</StyledHeader>
        <SectionParagraph>{subtitle}</SectionParagraph>
      </Flex>
      <HeroCTA ctaLabel={ctaLabel} ctaUrl={ctaUrl} />
    </Flex>
  </Flex>
);
